<p-toast></p-toast>

<!-- Warning message if item already exists -->
<p-messages *ngIf="alreadyExists" severity="warn">
    <ng-template pTemplate>
        <div class="ml-2">
            <i class="pi pi-exclamation-triangle"></i>
            <span class="ml-2">Cet item est déjà emprunté. Le nouvel emprunt remplacera l'emprunt existant.</span>
        </div>
    </ng-template>
</p-messages>

<p-messages *ngIf="warnSyncronisationEmplacement" severity="warn">
    <ng-template pTemplate>
        <div class="ml-2">
            <i class="pi pi-exclamation-triangle"></i>
            <span class="ml-2">La syncronisation de l'emplacement réel avec la division du portail Hamel sera automatiquement activée pour cet employé (e).</span>
        </div>
    </ng-template>
</p-messages>

<div class="p-fluid formgrid grid">

    <!-- Item Selection -->
    <div class="field col-12 md:col-6">
        <div class="flex align-items-center gap-1" style="margin-bottom: 0.5rem;">
            <label for="item">Item *</label>
            <a *ngIf="emprunt.item" class="pi pi-external-link text-primary" (click)="afficherItem(emprunt.item.itemId)" pTooltip="Afficher un apperçu de l'item"></a>
        </div>
        <div class="p-inputgroup">
            <input type="text" pInputText readonly [value]="emprunt.item ? emprunt.item.description + ' (' + emprunt.item.numero + ')' : 'Aucun item sélectionné'"
                placeholder="Sélectionner un item" (click)="selectionnerItem()">
            <button type="button" pButton icon="pi pi-search" class="p-button-outlined" (click)="selectionnerItem()"
                pTooltip="Sélectionner un item">
            </button>
        </div>
    </div>

    <!-- Employee Selection -->
    <div class="field col-12 md:col-6">
        <label for="employe">Employé *</label>
        <div class="p-inputgroup">
            <input type="text" pInputText readonly [value]="emprunt.employe ? emprunt.employe.prenom + ' ' + emprunt.employe.nom + ' (' + emprunt.employe.noEmploye + ')' : 'Aucun employé sélectionné'"
                placeholder="Sélectionner un employé" (click)="selectionnerEmploye()">
            <button type="button" pButton icon="pi pi-search" class="p-button-outlined" (click)="selectionnerEmploye()"
                pTooltip="Sélectionner un employé">
            </button>
        </div>
    </div>

    <!-- Start Date -->
    <div class="field col-12 md:col-6">
        <div class="flex flex-column gap-1 mb-1">
            <label for="dateAffectation">Date d'affectation *</label>
            <small class="text-500">Date à laquelle l'item sera affecté à l'employé</small>
        </div>
        <p-calendar [(ngModel)]="emprunt.dateAffectation" dateFormat="dd MM yy" [showIcon]="true"
            inputId="dateAffectation" placeholder="Sélectionner la date d'affectation"
            [minDate]="minDateAffectation" (onSelect)="onDateAffectationChange()">
        </p-calendar>
    </div>

    <!-- End Date (Optional) -->
    <div class="field col-12 md:col-6">
        <div class="flex flex-column gap-1 mb-1">
            <label for="dateRetour">Date de retour (optionnelle)</label>
            <small class="text-500">Si cette date est définie, un rappel vous sera envoyé lorsque l'item doit être retourné</small>
        </div>
        <p-calendar [(ngModel)]="emprunt.dateRetour" dateFormat="dd MM yy" [showIcon]="true" inputId="dateRetour"
            placeholder="Sélectionner la date de retour" [minDate]="minDateRetour" [showButtonBar]="true">
        </p-calendar>
    </div>

    <!-- Return Section -->
    <div class="field col-12" *ngIf="emprunt?.dateRetour">
        <p-card>
            <ng-template pTemplate="header">
                <div class="flex align-items-center gap-2 ml-3 mt-3">
                    <i class="pi pi-reply"></i>
                    <span class="font-bold">Informations de retour</span>
                </div>
            </ng-template>

            <div class="formgrid grid">
                <div class="field col-12">
                    <div class="flex flex-column gap-1 mb-1">
                        <label for="retourEmplacement">Emplacement de retour</label>
                        <small class="text-500">Spécifiez où l'item sera automatiquement retourné à la date de fin ou lors du retour manuel.</small>
                    </div>
                    <div class="p-inputgroup">
                        <input type="text" pInputText readonly
                            [value]="emprunt?.emplacementRetour ? emprunt?.emplacementRetour?.nom : 'Aucun emplacement sélectionné'"
                            placeholder="Sélectionner un emplacement"
                            (click)="selectionnerEmplacement(true)" [disabled]="emprunt?.employeRetour">
                        <button *ngIf="!emprunt?.emplacementRetour" type="button" pButton icon="pi pi-search" class="p-button-outlined" [disabled]="emprunt?.employeRetour"
                            pTooltip="Sélectionner un emplacement"
                            (click)="selectionnerEmplacement(true)">
                        </button>
                        <button *ngIf="emprunt?.emplacementRetour" type="button" pButton icon="pi pi-times" class="p-button-outlined"
                            pTooltip="Supprimer l'emplacement de retour"
                            (click)="emprunt.emplacementRetour = null; emprunt.emplacementRetourId = null;">
                        </button>
                    </div>
                </div>
            </div>
        </p-card>
    </div>

    <!-- Notes -->
    <div class="field col-12">
        <label for="note">Notes</label>
        <textarea pInputTextarea [(ngModel)]="emprunt.note" rows="3"
            placeholder="Ajouter des notes concernant cet emprunt..." inputId="note">
          </textarea>
    </div>

    <!-- Liaisons -->
    <div class="field col-12">
        <p-messages severity="warn" *ngIf="emprunt.empruntsEnfants.length > 0">
            <ng-template pTemplate>
                <div class="flex flex-column gap-2 w-full">
                    <span>Cet item a des liaisons avec d'autres items. Ceux-ci seront également empruntés.</span>
                    <p-dataView [value]="emprunt.empruntsEnfants" scrollHeight="500px">
                        <ng-template pTemplate="list" let-items>
                            @for (item of items; track item.empruntEnfantId) {
                                <p-card styleClass="mb-2 w-full">
                                    <div class="flex justify-content-between gap-2">
                                        <div class="flex align-items-start gap-3">
                                            <!-- Image -->
                                            <div class="flex-shrink-0">
                                                <div *ngIf="item.item.photoId" class="w-4rem h-4rem">
                                                    @defer (on viewport) {
                                                    <app-image-loader [documentId]="item.item.photoId" [width]="64" [height]="64" [title]="item.item.numero"></app-image-loader>
                                                    }
                                                    @placeholder {
                                                        <div class="flex align-items-center justify-content-center border-1 border-300 border-round" style="height: 64px; width: 64px;">
                                                            <p-skeleton width="64px" height="64px"></p-skeleton>
                                                        </div>
                                                    }
                                                </div>
                                                <div *ngIf="!item.item.photoId" class="w-4rem h-4rem border-1 border-300 border-round flex align-items-center justify-content-center">
                                                    <i class="pi pi-image text-gray-500"></i>
                                                </div>
                                            </div>
                                            
                                            <!-- Item Information -->
                                            <div class="flex-1">
                                                <div class="flex flex-column gap-2">
                                                    <div class="flex align-items-center gap-2">
                                                        <span class="font-bold text-lg">{{item.item.numero}}</span>
                                                    </div>
                                                    <div class="text-600 line-height-3">
                                                        {{item.item.description}}
                                                    </div>
                                                    <div class="flex flex-wrap gap-3 text-sm">
                                                        <div *ngIf="item.item.marque" class="flex align-items-center gap-1">
                                                            <span class="text-500">Marque:</span>
                                                            <span class="font-medium">{{item.item.marque}}</span>
                                                        </div>
                                                        <div *ngIf="item.item.modele" class="flex align-items-center gap-1">
                                                            <span class="text-500">Modèle:</span>
                                                            <span class="font-medium">{{item.item.modele}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <p-button icon="pi pi-external-link" (click)="afficherItem(item.item.itemId)" text pTooltip="Afficher un apperçu de l'item"></p-button>
                                    </div>
                                </p-card>
                            }
                        </ng-template>
                    </p-dataView>
                </div>
            </ng-template>
        </p-messages>
    </div>
</div>

<!-- Action Buttons -->
<div class="flex justify-content-end gap-2 mt-3">
    <button type="button" pButton label="Annuler" icon="pi pi-times" class="p-button-text p-button-secondary"
        (click)="annuler()">
    </button>
    <button type="button" pButton label="Enregistrer" icon="pi pi-check" class="p-button" [loading]="submitting"
        [disabled]="!emprunt?.item || !emprunt?.employe || !emprunt?.dateAffectation" (click)="enregistrer()">
    </button>
</div>

<p-sidebar [(visible)]="afficherDetailItem" [style]="{width:'95%'}" position="left" appendTo="body">
    <app-detail-item [itemId]="detailItemId" *ngIf="afficherDetailItem"></app-detail-item>
</p-sidebar>